import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  zh: {
    login: {
      title: '欢迎登录麦麦通渠道商平台',
      email: '邮箱',
      password: '密码',
      remember: '记住我',
      forgot: '忘记密码?',
      submit: '登录',
      register: '加入我们',
      noAccount: '没有账户?'
    },
    register: {
      title: '创建您的渠道商麦麦通账户',
      hasAccount: '已有账户?',
      login: '立即登录',
      email: '邮箱',
      verifyCode: '验证码',
      sendCode: '发送验证码',
      name: '姓名',
      password: '密码',
      confirmPassword: '确认密码',
      agree: '我已阅读并同意',
      userAgreement: '《用户协议》',
      and: '及',
      privacyPolicy: '《隐私协议》',
      submit: '立即注册'
    },
    forgotPassword: {
      title: '重置密码',
      subtitle: '请输入您的邮箱地址，我们将发送验证码到您的邮箱',
      email: '邮箱',
      verifyCode: '验证码',
      sendCode: '发送验证码',
      newPassword: '新密码',
      confirmPassword: '确认密码',
      submit: '重置密码',
      backToLogin: '返回登录',
      emailRequired: '请输入邮箱',
      emailInvalid: '请输入正确的邮箱地址',
      verifyCodeRequired: '请输入验证码',
      passwordRequired: '请输入新密码',
      passwordMin: '密码长度不能少于6位',
      confirmPasswordRequired: '请确认密码',
      passwordMismatch: '两次输入的密码不一致',
      codeSent: '验证码已发送',
      resetSuccess: '密码重置成功'
    },
    sidebar: {
      dashboard: '平台首页',
      collection: '收款',
      tradeOrder: '贸易单',
      tradeCollection: '贸易收款单',
      exchange: '换汇',
      exchangeOrder: '换汇订单',
      foreignExchange: '外汇管理',
      foreignExchangeList: '外汇列表',
      settlement: '结汇',
      settlementOrder: '结汇订单',
      settlementWithdrawOrder: '结汇出款订单',
      settlementQuota: '结汇额度查询',
      loan: '出款',
      transferRemittance: '转账汇款',
      fundManagement: '资金管理',
      myWallet: '我的钱包',
      accountManagement: '账户管理',
      foreignTradeAccount: '外贸收款账户',
      rmbSettlementAccount: '人民币结汇提现账户',
      overseasRemittanceAccount: '境外汇款账户',
      my: '我的',
      announcementList: '公告列表',
      enterpriseCertification: '企业认证',
      accountSecurity: '账号与安全',
      roleManagement: '角色管理',
      operatorManagement: '操作员管理',
      keyManagement: '公私钥管理'
    },
    header: {
      company: 'Hong Kong Techwin Co., Limited'
    },
    dashboard: {
      title: '资产概览',
      pending: '待办事项',
      exchangeRate: '交易牌价',
      bankHoliday: '银行假期日历',
      attention: '关注币种'
    },
    language: {
      chinese: '中文',
      english: 'English'
    },
    userInfo: {
      merchantId: '商户编号',
      merchantName: '商户名称',
      operatorName: '操作员名称',
      loginEmail: '登陆邮箱',
      logout: '退出登录'
    },
    unavailable: {
      description: '该功能暂未开通，敬请期待！',
      back: '返回首页'
    },
    enterprise: {
      title: '企业认证',
      activateAccount: 'ACTIVATE YOUR ACCOUNT',
      beforeJoin: '商户入网成功后，方可进行相关业务服务！',
      afterJoin: '商户入网成功',
      addBasicInfo: '添加企业基本信息',
      addBusinessInfo: 'Add Business Information'
    }
  },
  en: {
    login: {
      title: 'Login to your Paymmt Account',
      email: 'Email',
      password: 'Password',
      remember: 'Remember Me',
      forgot: 'Forgot Password?',
      submit: 'Login',
      register: 'Join Us',
      noAccount: 'Don\'t have an account?'
    },
    register: {
      title: 'Create Your Channel Partner Paymmt Account',
      hasAccount: 'Already have an account?',
      login: 'Login Now',
      email: 'Email',
      verifyCode: 'Verification Code',
      sendCode: 'Send Code',
      name: 'Name',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      agree: 'I have read and agree to',
      userAgreement: 'User Agreement',
      and: 'and',
      privacyPolicy: 'Privacy Policy',
      submit: 'Register Now'
    },
    forgotPassword: {
      title: 'Reset Password',
      subtitle: 'Please enter your email address, we will send a verification code to your email',
      email: 'Email',
      verifyCode: 'Verification Code',
      sendCode: 'Send Code',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      submit: 'Reset Password',
      backToLogin: 'Back to Login',
      emailRequired: 'Please enter email',
      emailInvalid: 'Please enter a valid email address',
      verifyCodeRequired: 'Please enter verification code',
      passwordRequired: 'Please enter new password',
      passwordMin: 'Password must be at least 6 characters',
      confirmPasswordRequired: 'Please confirm password',
      passwordMismatch: 'Passwords do not match',
      codeSent: 'Verification code sent',
      resetSuccess: 'Password reset successfully'
    },
    sidebar: {
      dashboard: 'Home',
      collection: 'Pay-ins',
      tradeOrder: 'Trade Order',
      tradeCollection: 'Trade receipt',
      exchange: 'Conversions',
      exchangeOrder: 'Exchange Order',
      foreignExchange: 'Foreign Exchange',
      foreignExchangeList: 'Foreign Exchange List',
      settlement: 'Settlement',
      settlementOrder: 'Settlement Order',
      settlementWithdrawOrder: 'Settlement Withdraw Order',
      settlementQuota: 'Settlement Quota',
      loan: 'Loan',
      transferRemittance: 'Transfer Remittance',
      fundManagement: 'Fund Management',
      myWallet: 'My Wallet',
      accountManagement: 'Account Management',
      foreignTradeAccount: 'Foreign Trade Account',
      rmbSettlementAccount: 'RMB Settlement Account',
      overseasRemittanceAccount: 'Overseas Remittance Account',
      my: 'My',
      announcementList: 'Announcement List',
      enterpriseCertification: 'Enterprise Certification',
      accountSecurity: 'Account Security',
      roleManagement: 'Role Management',
      operatorManagement: 'Operator Management',
      keyManagement: 'Key Management'
    },
    header: {
      company: 'Hong Kong Techwin Co., Limited'
    },
    dashboard: {
      title: 'Asset Overview',
      pending: 'Pending Tasks',
      exchangeRate: 'Exchange Rate',
      bankHoliday: 'Bank Holiday Calendar',
      attention: 'Attention Currencies'
    },
    language: {
      chinese: '中文',
      english: 'English'
    },
    userInfo: {
      merchantId: 'Merchant ID',
      merchantName: 'Merchant Name',
      operatorName: 'Operator Name',
      loginEmail: 'Login Email',
      logout: 'Logout'
    },
    unavailable: {
      description: 'This feature is not yet available, please stay tuned!',
      back: 'Back to Home'
    },
    enterprise: {
      title: 'Enterprise Certification',
      activateAccount: 'ACTIVATE YOUR ACCOUNT',
      beforeJoin: 'After the merchant has successfully joined the network, You can carry out the business services',
      afterJoin: 'Merchant joined successfully',
      addBasicInfo: 'Add Business Information',
      addBusinessInfo: 'Add Business Information'
    }
  }
}

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh',
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js